import { Navigate } from 'react-router-dom';

export default function PrivateRoute({ children }) {
  const storedUser = localStorage.getItem('usuario');

  if (!storedUser || storedUser === "undefined") {
    return <Navigate to="/login" replace />;
  }

  try {
    JSON.parse(storedUser);
    return children;
  } catch {
    localStorage.removeItem('usuario');
    return <Navigate to="/login" replace />;
  }
}